<template>
    <section :class="groupClass">
        <template v-if="label">
            <h4 class="content-group__label">
                {{ label }}
            </h4>
        </template>

        <div class="content-group__body">
            <slot></slot>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            label: { type: String, default: null },
            isCompact: { type: Boolean, default: false },
        },

        computed: {
            groupClass() {
                return {
                    'content-group': true,
                    'content-group--is-compact': this.isCompact,
                }
            },
        },
    }
</script>
